import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
//Para los select
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import purple from '@material-ui/core/colors/purple';
import Switch from '@material-ui/core/Switch';


const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  chip: {
    marginRight: theme.spacing.unit,
  },
  section1: {
    margin: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px`,
  },
  section2: {
    margin: theme.spacing.unit * 2,
  },
  section3: {
    margin: `${theme.spacing.unit * 6}px ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`,
    maxWidth:'50px',
  },
  colorSwitchBase: {
    color: purple[300],
    '&$colorChecked': {
      color: purple[500],
      '& + $colorBar': {
        backgroundColor: purple[500],
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});

class  Filters extends React.Component  {
  state={}

  handleChange = name => event => 
  {
    this.setState({ [name]: event.target.checked });
    if( event.target.checked)
    {
      this.props.handleChange({target:{value:1,id:'period_type'}}) 
    }else
    {
      this.props.handleChange({target:{value:0,id:'period_type'}}) 
    }
  }

  render()
  {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <div className={classes.section1}>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography gutterBottom variant="h6">
                Project Life Cycle
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={24}>
            <Grid item sm={3}>
              <TextField
                style={{width: '90%'}}
                id="start_date"
                label="Start Date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                value={this.props.filters.start_date}
                onChange={this.props.handleChange}
                error={this.props.errores.start_date}
                helperText={this.props.errores.start_date}
              />
            </Grid>
            <Grid item sm={3}>
              <TextField
                style={{width: '90%'}}
                id="end_date"
                label="End Date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                value={this.props.filters.end_date}
                onChange={this.props.handleChange}
                error={this.props.errores.end_date}
                helperText={this.props.errores.end_date}
              />
            </Grid>
             <Grid item sm={2} >
              <div style={{marginTop:'5px'}}>
                <InputLabel htmlFor="period_type" style={{marginRight:'10px'}}>Month</InputLabel>
                <Switch
                  classes={{
                    switchBase: classes.iOSSwitchBase,
                    bar: classes.iOSBar,
                    icon: classes.iOSIcon,
                    iconChecked: classes.iOSIconChecked,
                    checked: classes.iOSChecked,
                  }}
                  disableRipple
                  checked={this.state.checkedB}
                  onChange={this.handleChange('checkedB')}
                  value="checkedB"
                />
                <InputLabel htmlFor="period_type" style={{marginRight:'10px'}}>Week</InputLabel>
              </div>
            </Grid>
            <Grid item sm={2} style={{marginTop:'10px'}}>
              <InputLabel htmlFor="period_number" style={{marginRight:'10px'}}>Number per Period</InputLabel>
              <Select
                required
                id="period_number"
                name="period_number"
                value={this.props.filters.period_number}
                onChange={this.props.handleChange}
                error={this.props.errores.period_number}
                helperText={this.props.errores.period_number}
              >
                <MenuItem native="true" key={1} value={1} selected>
                  1
                </MenuItem>
                <MenuItem native="true" key={2} value={2}>
                  2
                </MenuItem>
                <MenuItem native="true" key={3} value={3}>
                  3
                </MenuItem>
              </Select>
            </Grid>
            
            <Grid item sm={1}>
               <Button onClick={this.props.getResult}  variant="contained" color="primary" fullWidth>
                  Generate
              </Button>
              <span style={{color:"red", fontSize:"0.8em", position:"relative"}}>{this.props.correct_last_period?"":"The last RP has not the selected duration, the suggest finish date is: " + this.props.correct_last_period_date}</span>
            </Grid>
            <Grid item sm={1}>
               <Button onClick={this.props.publishProject}  variant="contained" color="primary" disabled={!this.props.showPublishButton} fullWidth>
                  Publish
              </Button>
            </Grid>
          </Grid>
        </div>
      </Paper>
    );
  }
}

Filters.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles)(Filters);



// WEBPACK FOOTER //
// ./src/features/daily/Filters.js